// import external dependencies
/* eslint-disable */
import "./modules/nav";
import "./modules/jquery.maskMoney";
import {onINP} from 'web-vitals/attribution';
/* eslint-enable */

function sendToGoogleAnalytics ({name, value, id, attribution}) {
	// Destructure the attribution object:
	const {eventEntry, eventTarget, eventType, loadState} = attribution;

	// Get timings from the event timing entry:
	const {startTime, processingStart, processingEnd, duration, interactionId} = eventEntry;

	const eventParams = {
		// The page's INP value:
		metric_inp_value: value,
		// A unique ID for the page session, which is useful
		// for computing totals when you group by the ID.
		metric_id: id,
		// The event target (a CSS selector string pointing
		// to the element responsible for the interaction):
		metric_inp_event_target: eventTarget,
		// The type of event that triggered the interaction:
		metric_inp_event_type: eventType,
		// Whether the page was loaded when the interaction
		// took place. Useful for identifying startup versus
		// post-load interactions:
		metric_inp_load_state: loadState,
		// The time (in milliseconds) after page load when
		// the interaction took place:
		metric_inp_start_time: startTime,
		// When processing of the event callbacks in the
		// interaction started to run:
		metric_inp_processing_start: processingStart,
		// When processing of the event callbacks in the
		// interaction finished:
		metric_inp_processing_end: processingEnd,
		// The total duration of the interaction. Note: this
		// value is rounded to 8 milliseconds of granularity:
		metric_inp_duration: duration,
		// The interaction ID assigned to the interaction by
		// the Event Timing API. This could be useful in cases
		// where you might want to aggregate related events:
		metric_inp_interaction_id: interactionId,
	};

	// Send to Google Analytics
	// eslint-disable-next-line
	gtag('event', name, eventParams);
}

// Pass the reporting function to the web-vitals INP reporter:
onINP(sendToGoogleAnalytics);

jQuery(document).ready(() => {
	//Fade-in entry to avoid CLS
	$('.hero, .site-header').css('opacity', '1');

	// Passive event listeners
	jQuery.event.special.touchstart = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
		},
	};
	jQuery.event.special.touchmove = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
		},
	};
	$('.wp-block-table > table').find('thead').find('tr').each( function() {
		var obj = {};
		$(this).find('th').each(function(k) { obj[k] = $(this).text(); });
		$(this).parent().parent().find('tbody').find('tr').each(function() {
			$(this).find('td').each(function(k) { $(this).attr('data-th', obj[k]); $(this).addClass('flexibletable')});
		});
	});
	$('.wp-block-table.ask-credit').find('table').find('tr').each(function() {
		$(this).find('td').each(function() {
			$(this).addClass('ask-credit');
			$(this).addClass('table-click-ga');
		});
		// $(this).addClass('ask-credit');
	});
	$('.wp-block-image.ask-credit').each(function(){
		if($(this).find('a').length == 0) {
			$(this).find('img').addClass('ask-credit');
			$(this).find('img').addClass('image-click-ga');
		} else {
			$(this).find('a').addClass('image-click-ga');
		}
	});

	//start RangeSlidder above the fold
	$('#rangeOutput').maskMoney({ precision: 0, suffix: '€', thousands: ' ', selectAllOnFocus: true});
	$('#rangeOutput').maskMoney('mask');

	const eventLLS = new Event('lazyLoadScripts');
	var app = {
		init: function() {
			window.addEventListener("scroll", function() {
				if (window.__he == undefined) {
					app.load();
				}
			});
			window.addEventListener("mousemove", function() {
				if (window.__he == undefined) {
					app.load();
				}
			});
		},
		load: function() {
			window["__he"] = true;
			setTimeout(function (){
				window.dispatchEvent(eventLLS);
				console.log('Lazyload Scripts triggered')
			}, 500);
		},
	};

	window.addEventListener('lazyLoadScripts', function () {
		var jsScript = document.createElement('script');
		jsScript.src = '/wp-content/themes/institutional-finance/dist/scripts/defered.js?v=1.8.40';
		document.body.appendChild(jsScript);
		jsScript = document.createElement('script');
		jsScript.src = '/wp-content/themes/institutional-finance/assets/scripts/modal-form-validate.js?v=1.1.0';
		document.body.appendChild(jsScript);
	}, false);
	app.init();

	if (location.hash === '#ask-credit') {
		window["__he"] = true;
		window.dispatchEvent(eventLLS);
		setTimeout(function(){
			window.dispatchEvent(new Event('hash-link-open-cta'));
			$("#myModal").show();
			$("html").css('overflow-y','hidden');
		}, 1000);
	}


	var lastScrollTop = 0;
	$(window).on('scroll', function() {
		var divOffset = $('.site-header').offset().top;
		var windowScroll = $(window).scrollTop();

		var windowWidth = $(window).width();

		if (divOffset <= windowScroll) {
			if(!$('.cookie-consent-wrapper.top').hasClass('already-clicked')) {
				$('.site-header').css('position', 'fixed');
				$('.site-header').css('top', '0');
			}

		}

		if(windowScroll > lastScrollTop) {
			// console.log('scrolldown');
		} else {
			if(!$('.cookie-consent-wrapper.top').hasClass('already-clicked')) {
				if(isBottomOfDivVisible($('.cookie-consent-wrapper.top'))) {
					if(windowWidth < 768) {
						$('.site-header').css('position', 'absolute');
						$('.site-header').css('top', '107px');
						if($('body').hasClass('postid-104610')) {
							$('.site-header').css('top', '132px');
						}
					} else if(windowWidth >= 768 && windowWidth < 1210) {
						$('.site-header').css('position', 'absolute');
						$('.site-header').css('top', '82px');
					} else if(windowWidth > 1210) {
						$('.site-header').css('position', 'absolute');
						$('.site-header').css('top', '84px');
					}

				}
			}
		}








		if($('.cookie-consent-wrapper.top').hasClass('already-clicked')) {
			var initialTop = 30;
			if($('body').hasClass('postid-104610') && windowWidth < 768) {
				initialTop = 55;
			}
			console.log(initialTop);

			var newTop = initialTop - windowScroll;

			if(newTop < 0) {
				$('.site-header').css('top', '0px');
				$('.site-header').css('position', 'fixed');
				return;
			}
			$('.site-header').css('top', newTop + 'px');
			$('.site-header').css('position', 'fixed');
		}











		lastScrollTop = windowScroll;
	});

	function isBottomOfDivVisible($div) {
		var scrollTop = $(window).scrollTop();
		var windowHeight = $(window).height();
		var divOffset = $div.offset().top;
		var divHeight = $div.outerHeight();
		return (divOffset + divHeight <= scrollTop + windowHeight) && (divOffset + divHeight >= scrollTop);
	}

	let tablesWrappedByFigure = document.querySelectorAll('figure.wp-block-table');

	tablesWrappedByFigure.forEach(function(tableWrappedByFigure) {
		tableWrappedByFigure.insertAdjacentHTML('afterbegin', '<div class="wp-figure-table-wrapper"></div>');
		let wpFigureTableWrapper = tableWrappedByFigure.querySelector('.wp-figure-table-wrapper');
		let table = tableWrappedByFigure.querySelector('table');
		wpFigureTableWrapper.innerHTML = table.outerHTML;
		wpFigureTableWrapper.insertAdjacentHTML('afterbegin', '<div class="custom-scrollbar"><div class="scrollbar-thumb"></div></div>');
		let tableWrappedByFigureChildren = tableWrappedByFigure.children;
		for (let child of tableWrappedByFigureChildren) {
			if (child.tagName.toLowerCase() === 'table') {
				child.remove(); // Removes the immediate child table
				break; // Exit loop after removing
			}
		}
	});




});



// WEBPACK FOOTER //
// ./scripts/main.js